import { useState } from "react";
import Answered from "./Answered";

function MCQuestion(props) {
  const [answered, setAnswered] = useState(false);
  const [correct, setCorrect] = useState();
  const [selected, setSelected] = useState("none");

  const {
    question,
    number,
    choices,
    answer,
    image,
    alt,
    explanation,
    link,
    setNumAnswered,
    setNumCorrect,
    imgPath,
    answer_i,
  } = props;

  const handleClick = (e) => {
    setAnswered(true);
    setNumAnswered((c) => c + 1);
    setSelected(parseInt(e.target.name));
    if (e.target.value === "true") {
      setCorrect(true);
      setNumCorrect((c) => c + 1);
    } else {
      setCorrect(false);
    }
  };

  const changeButton = (i) => {
    if (!answered) {
      return "Choice AllButton";
    } else if (correct && i === answer_i) {
      return "Correct AllButton";
    } else if (!correct && i === answer_i) {
      return "IncorrectCorrect AllButton";
    } else if (!correct && i === selected) {
      return "Incorrect AllButton";
    } else {
      return "Other AllButton";
    }
  };

  return (
    <div>
      <div className="Question">
        <h4 className="num">{number}.</h4>
        {image != null && image.length > 0 && (
          <img src={imgPath + image} alt={alt} />
        )}
        <h4>{question}</h4>
        <div className="Options">
          {choices.map((choice, i) => (
            <div className="ButtonGroup" key={`Q${number}.${i}`}>
              <button
                className={changeButton(i)}
                onClick={handleClick}
                value={i === answer_i}
                name={i}
                disabled={answered}
              >
                {choice}
                {i === answer_i && selected !== "none" ? (
                  <img
                    src={process.env.PUBLIC_URL + "/images/happy-bear.png"}
                    alt={"happy bear for correct answer"}
                    className="ChoiceBear"
                  />
                ) : (
                  i === selected &&
                  !correct && (
                    <img
                      src={process.env.PUBLIC_URL + "/images/sad-bear.png"}
                      alt={"sad bear for wrong answer"}
                      className="ChoiceBear"
                    />
                  )
                )}
              </button>
            </div>
          ))}
          {answered && (
            <Answered correct={correct} explanation={explanation} link={link} />
          )}
          {/* <div className="MoreInfo">
              {correct ? (
                <p>
                  <b>Correct!</b> {explanation}
                </p>
              ) : (
                <p>
                  <b>Incorrect!</b> {explanation}
                </p>
              )}
              {link && (
                <a href={link} target="_blank" rel="noreferrer noopener">
                  Read more! &rarr;
                </a>
              )}
            </div> */}
        </div>
      </div>
      <hr />
    </div>
  );
}

export default MCQuestion;
